// extracted by mini-css-extract-plugin
export var table = "_yd-0";